module.exports = __webpack_public_path__ + "img/wallet-credit-card.dd1a7a27.svg";